<div class="select-edit-container">
  <mat-form-field>
    <ng-container *ngIf="model.label" ngProjectAs="mat-label">
      <mat-label [innerHTML]="model.label"></mat-label>
    </ng-container>
    <mat-select
      [id]="model.id"
      [(ngModel)]="model.value"
      (ngModelChange)="onChange()"
      [ngModelOptions]="{ standalone: true }"
      [compareWith]="model.compareWithFn"
      [placeholder]="model.placeholder"
      [required]="model.required"
      [disabled]="model.disabled"
      #selectModel="ngModel"
      data-test="gsm-select-edit_select"
    >
      <mat-option *ngFor="let option of model.options$ | async" [value]="option?.value">{{ getLabel(option) }}
      </mat-option>
    </mat-select>
    <mat-hint class="hint-text" *ngIf="model.hint !== null" align="start" [innerHTML]="model.hint"></mat-hint>
    <mat-error *ngFor="let message of errorMessages">{{ message }}</mat-error>
  </mat-form-field>
  <button *ngIf="isEditable" mat-icon-button class="action-button" (click)="onEditClick()"
          data-test="gsm-select-edit_edit-btn">
    <mat-icon>edit</mat-icon>
  </button>
</div>
